import r1png from "./images/reasons/1.png";
import r2png from "./images/reasons/2.png";
import r3png from "./images/reasons/3.png";
import r3webp from "./images/reasons/3.webp";
import r1webp from "./images/reasons/1.webp";
import r2webp from "./images/reasons/2.webp";

import c1png from "./images/clip/1.png";
import c1webp from "./images/clip/1.webp";
import c2png from "./images/clip/2.png";
import c2webp from "./images/clip/2.webp";
import c3png from "./images/clip/3.png";
import c3webp from "./images/clip/3.webp";
import c4png from "./images/clip/4.png";
import c4webp from "./images/clip/4.webp";
import c5png from "./images/clip/5.png";
import c5webp from "./images/clip/5.webp";

import l1_1png from "./images/life/1/1.png";
import l1_1webp from "./images/life/1/1.webp";
import l1_2png from "./images/life/1/2.png";
import l1_2webp from "./images/life/1/2.webp";
import l1_3png from "./images/life/1/3.png";
import l1_3webp from "./images/life/1/3.webp";
import l1_4png from "./images/life/1/4.png";
import l1_4webp from "./images/life/1/4.webp";
import l1_5png from "./images/life/1/5.png";
import l1_5webp from "./images/life/1/5.webp";
import l1_6png from "./images/life/1/6.png";
import l1_6webp from "./images/life/1/6.webp";
import l1_7png from "./images/life/1/7.png";
import l1_7webp from "./images/life/1/7.webp";
import l1_8png from "./images/life/1/8.png";
import l1_8webp from "./images/life/1/8.webp";
import l1_9png from "./images/life/1/9.png";
import l1_9webp from "./images/life/1/9.webp";
import l1_10png from "./images/life/1/10.png";
import l1_10webp from "./images/life/1/10.webp";
import l1_11png from "./images/life/1/11.png";
import l1_11webp from "./images/life/1/11.webp";

import l2_1png from "./images/life/2/1.png";
import l2_1webp from "./images/life/2/1.webp";
import l2_2png from "./images/life/2/2.png";
import l2_2webp from "./images/life/2/2.webp";
import l2_3png from "./images/life/2/3.png";
import l2_3webp from "./images/life/2/3.webp";
import l2_4png from "./images/life/2/4.png";
import l2_4webp from "./images/life/2/4.webp";
import l2_5png from "./images/life/2/5.png";
import l2_5webp from "./images/life/2/5.webp";
import l2_6png from "./images/life/2/6.png";
import l2_6webp from "./images/life/2/6.webp";
import l2_7png from "./images/life/2/7.png";
import l2_7webp from "./images/life/2/7.webp";
import l2_8png from "./images/life/2/8.png";
import l2_8webp from "./images/life/2/8.webp";
import l2_9png from "./images/life/2/9.png";
import l2_9webp from "./images/life/2/9.webp";
import l2_10png from "./images/life/2/10.png";
import l2_10webp from "./images/life/2/10.webp";
import l2_11png from "./images/life/2/11.png";
import l2_11webp from "./images/life/2/11.webp";

const timeline = [
  {
    year: "2017",
    text: "Igor and Boris decided to fill the gap in mobile automation services",
  },
  {
    year: "2018",
    text: "End to end development service launch",
  },
  {
    year: "2019",
    text: "Launch of Engenious University bootcamp in Silicon Valley",
  },
  {
    year: "2020",
    text: "Successful projects with 62 Fortune 500 companies and emerging startups",
  },
  {
    year: "2021",
    text: "First online course receives best feedback",
  },
  {
    year: "2022",
    text: "Split into two areas: Team Extension & Managed Delivery",
  },
];

const reasons = [
  {
    images: {
      png: r1png,
      webp: r1webp,
    },
    title: "Learning and development",
    list: [
      "English lessons",
      "Paid industry conferences and meetups",
      "Full or partial compensation for courses, education",
    ],
  },
  {
    images: {
      png: r2png,
      webp: r2webp,
    },
    title: "Entertainment",
    list: ["Teambuilding", "International cuisine days", "Sports activities"],
  },
  {
    images: {
      png: r3png,
      webp: r3webp,
    },
    title: "Comfortable working conditions",
    list: [
      "Free lunch",
      "Flexible working hours",
      "Possibility to work remotely or in the office",
    ],
  },
];

const clip = [
  {
    images: {
      png: c1png,
      webp: c1webp,
    },
    title: "People",
    text: `We invest in our employees' personal and professional growth.`,
  },
  {
    images: {
      png: c2png,
      webp: c2webp,
    },
    title: "Customer focus",
    text: `We support our customers' bravest ideas.`,
  },
  {
    images: {
      png: c3png,
      webp: c3webp,
    },
    title: "Flexibility",
    text: `We are quick to adapt to new environments.`,
  },
  {
    images: {
      png: c4png,
      webp: c4webp,
    },
    title: "Speed",
    text: `We make fast decisions to get fast results.`,
  },
  {
    images: {
      png: c5png,
      webp: c5webp,
    },
    title: "Striving",
    text: `We make the world a more technologically advanced place.`,
  },
];

const life_2 = [
  {
    images: {
      png: l2_1png,
      webp: l2_1webp,
    },
  },
  {
    images: {
      png: l2_2png,
      webp: l2_2webp,
    },
  },
  {
    images: {
      png: l2_3png,
      webp: l2_3webp,
    },
  },
  {
    images: {
      png: l2_4png,
      webp: l2_4webp,
    },
  },
  {
    images: {
      png: l2_5png,
      webp: l2_5webp,
    },
  },
  {
    images: {
      png: l2_6png,
      webp: l2_6webp,
    },
  },
  {
    images: {
      png: l2_7png,
      webp: l2_7webp,
    },
  },
  {
    images: {
      png: l2_8png,
      webp: l2_8webp,
    },
  },
  {
    images: {
      png: l2_9png,
      webp: l2_9webp,
    },
  },
  {
    images: {
      png: l2_10png,
      webp: l2_10webp,
    },
  },
  {
    images: {
      png: l2_11png,
      webp: l2_11webp,
    },
  },
];
const life_1 = [
  {
    images: {
      png: l1_1png,
      webp: l1_1webp,
    },
  },
  {
    images: {
      png: l1_2png,
      webp: l1_2webp,
    },
  },
  {
    images: {
      png: l1_3png,
      webp: l1_3webp,
    },
  },
  {
    images: {
      png: l1_4png,
      webp: l1_4webp,
    },
  },
  {
    images: {
      png: l1_5png,
      webp: l1_5webp,
    },
  },
  {
    images: {
      png: l1_6png,
      webp: l1_6webp,
    },
  },
  {
    images: {
      png: l1_7png,
      webp: l1_7webp,
    },
  },
  {
    images: {
      png: l1_8png,
      webp: l1_8webp,
    },
  },
  {
    images: {
      png: l1_9png,
      webp: l1_9webp,
    },
  },
  {
    images: {
      png: l1_10png,
      webp: l1_10webp,
    },
  },
  {
    images: {
      png: l1_11png,
      webp: l1_11webp,
    },
  },
];

export { timeline, reasons, clip, life_1, life_2 };
